import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });
  const [isSending, setIsSending] = useState(false);
  const [lastCommand, setLastCommand] = useState('');

  const simulateTyping = (text) => {
    setLastCommand(text);
    setIsSending(true);
    setTimeout(() => setIsSending(false), 2000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    simulateTyping('Sending message...');
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  return (
    <section id="contact" className="contact-section">
      <div className="terminal-window">
        <div className="terminal-header">
          <div className="terminal-buttons">
            <span className="terminal-button close"></span>
            <span className="terminal-button minimize"></span>
            <span className="terminal-button zoom"></span>
          </div>
          <span className="terminal-title">contact.sh ~ running</span>
          <div className="terminal-stats">
            <span className="memory">mem: 64MB</span>
            <span className="cpu">cpu: 2%</span>
          </div>
        </div>
        
        <div className="terminal-content">
          <div className="command-line">
            <span className="prompt">guest@portfolio</span>
            <span className="separator">:</span>
            <span className="directory">~/contact</span>
            <span className="separator">$</span>
            <span className="command">./init-contact.sh</span>
          </div>
          
          <div className="output-block">
            <div className="ascii-art">
              {`
   _____          _            _   
  / ____|        | |          | |  
 | |     ___   __| |_   _  ___| |_ 
 | |    / _ \\ / _  | | | |/ __| __|
 | |___| (_) | (_| | |_| | (__| |_ 
  \\_____\\___/ \\__,_|\\__,_|\\___|\\__|
              `}
            </div>
            
            <div className="status-line">
              <span className="status-icon online"></span>
              <span>Status: Online and ready to connect</span>
            </div>

            <div className="contact-info">
              <div className="info-line">
                <span className="label">[EMAIL]</span>
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=vedantmarathe050104@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="email-link"
                >
                  vedantmarathe050104@gmail.com
                </a>
              </div>
              
              <div className="info-line">
                <span className="label">[WHATSAPP]</span>
                <a
                  href="https://api.whatsapp.com/send?phone=9620374123&text=Hello!"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                >
                  +91 9620374123
                </a>
              </div>
            </div>
          </div>

          <div className="command-line">
            <span className="prompt">guest@portfolio</span>
            <span className="separator">:</span>
            <span className="directory">~/contact</span>
            <span className="separator">$</span>
            <span className="command">./compose-message.sh</span>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <div className="input-label">
                <span className="prompt">&gt;</span>
                <span className="label">FROM:</span>
              </div>
              <input 
                type="email" 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder="your@email.com"
                required 
              />
            </div>
            
            <div className="input-group">
              <div className="input-label">
                <span className="prompt">&gt;</span>
                <span className="label">MESSAGE:</span>
              </div>
              <textarea 
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                placeholder="Type your message here..."
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn" disabled={isSending}>
              <span className="prompt">&gt;</span>
              {isSending ? 'Sending...' : './send-message.sh'}
              <span className="btn-icon">{isSending ? '⟳' : '▶'}</span>
            </button>
          </form>

          {lastCommand && (
            <div className="command-output">
              <span className="prompt">$</span>
              <span className="output">{lastCommand}</span>
              {isSending && <span className="loading-indicator">...</span>}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
